import { UsersReportPage } from '@/features/users/components/users-report/users-report-page.component';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/reports')({
  component: UsersReportPage,
  beforeLoad: async () => {
    // A API restringe aos grupos da seguradora além da permissão.
    const hasPermission = await requirePermissions(['identity.users.read']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});
